import { ArrowLeftIcon } from "@heroicons/react/20/solid"
import { ReactNode } from "react"
import Button from "./Button"

const DashboardTopbar = ({
  title,
  badge,
  backHref,
  children,
}: {
  title: string
  badge?: string
  backHref?: string
  children?: ReactNode
}) => (
  <div className="padding z-20 flex shrink-0 flex-wrap items-center justify-between gap-x-4 gap-y-3 border-b border-gray-200 bg-white py-4 shadow-xs sm:sticky sm:top-0 sm:h-18 sm:gap-x-6">
    <div className="flex items-center gap-x-4">
      {backHref && (
        <Button
          size="sm"
          style="secondary"
          className="xl:hidden"
          href={backHref}
        >
          <span className="sr-only">Go back</span>
          <ArrowLeftIcon className="h-5 w-5" />
        </Button>
      )}
      <h1 className="line-clamp-1 text-lg font-semibold text-gray-900">
        {title}
      </h1>
      {badge ? (
        <span className="rounded-md bg-gray-100 px-1.5 py-0.5 text-xs font-medium text-gray-500 ring-1 ring-gray-200 ring-inset">
          {badge}
        </span>
      ) : null}
    </div>
    {children && <div className="flex items-center gap-x-1.5">{children}</div>}
  </div>
)

export default DashboardTopbar
